import React, { useContext } from "react";
import { Field } from "react-final-form";
import { Button } from "components/ui/button";
import { Checkbox } from "components/ui/checkbox";
import { IntlContext } from "context";
import { useForgotPasswordDialog } from "context/ForgotPasswordDialog";

type RememberMeFieldProps = {
    onForgotPassword: () => void;
};

const RememberMeField: React.FC<RememberMeFieldProps> = ({ onForgotPassword }) => {
    const intl = useContext(IntlContext);
    const { actions: { openForgotPassword } } = useForgotPasswordDialog();

    return (
        <div className="flex items-center justify-between">
            <label className="flex cursor-pointer items-center gap-2">
                <Field name="rememberMe" type="checkbox">
                    {({ input }) => (
                        <Checkbox
                            id="rememberMe"
                            checked={input.checked}
                            onCheckedChange={(checked) => input.onChange(checked === true)}
                            onBlur={input.onBlur}
                            onFocus={input.onFocus}
                        />
                    )}
                </Field>
                <span className="font-nunito text-sm font-medium leading-5 text-slate-600">
                    {intl.formatMessage("authentication.login.action.remember_me")}
                </span>
            </label>
            <Button
                type="button"
                variant="link"
                size="none"
                className="font-nunito text-sm font-bold leading-5 text-indigo-600"
                onClick={() => {
                    onForgotPassword();
                    openForgotPassword();
                }}
            >
                {intl.formatMessage("authentication.login.action.forgot_password")}
            </Button>
        </div>
    );
};

export default RememberMeField;
